import React from "react";
import { useNavigate } from "react-router-dom";

function Terms() {
  const navigate = useNavigate();

 return (
  <div className="bg-black text-white min-h-screen px-6 py-12">
    {/* Back Button */}
    <button
      onClick={() => navigate("/")}
      className="mb-8 text-sm bg-white/10 px-4 py-2 rounded-lg hover:bg-white/20 transition"
    >
      ← Back to Home
    </button>

    <div className="max-w-4xl mx-auto space-y-8">
      <h1 className="text-3xl font-bold text-purple-400">Terms & Conditions</h1>
      <p className="text-white/70 text-sm">
        Last updated: {new Date().toLocaleDateString()}
      </p>

      {/* Intro */}
      <section>
        <h2 className="text-xl font-semibold mb-2">1. Agreement to Terms</h2>
        <p className="text-white/80">
          By creating an account, accessing, or using VintariAI (“the Service”),
          you acknowledge that you have read, understood, and agree to be bound
          by these Terms & Conditions. If you do not agree, do not use the Service.  
          These Terms apply to all users, including free and paid subscribers. 
        </p>
      </section>

      {/* Accounts & Eligibility */}
      <section>
        <h2 className="text-xl font-semibold mb-2">2. Accounts & Eligibility</h2>
        <p className="text-white/80">
          You are responsible for safeguarding your login credentials and for all
          activities under your account. By using the Service, you represent that
          you have the legal capacity to enter into a binding contract in your
          jurisdiction. We reserve the right to suspend or terminate accounts at
          our discretion if these Terms are violated.
        </p>
      </section>

      {/* Plans & Billing */}
      <section>
        <h2 className="text-xl font-semibold mb-2">3. Subscription Plans & Billing</h2>
        <p className="text-white/80">
          VintariAI offers Free, Professional, and Elite individual subscription
          plans. Multi-seat enterprise access is available by request through our
          sales team. Subscriptions are billed in advance on a recurring basis
          (monthly or annually, depending on your selection). By subscribing, you
          authorize us to charge your payment method on a recurring basis until
          canceled. Subscriptions automatically renew unless canceled before the
          renewal date.
        </p>
        <p className="text-white/80 mt-2">
          Payments are processed by third-party providers (e.g., Stripe). We are
          not responsible for errors, security breaches, or service issues caused
          by such providers.
        </p>
      </section>

      {/* Cancellation & Refunds */}
<section>
  <h2 className="text-xl font-semibold mb-2">4. Cancellation & Refund Policy</h2>
  <p className="text-white/80">
    You may cancel your individual subscription at any time. Access will continue
    until the end of the current billing cycle. To cancel, you must send us a
    message through our official contact form so that we can process your
    cancellation. We do not provide pro-rated refunds for unused time unless
    required by law. Refund requests due to billing errors will be reviewed on a
    case-by-case basis. By subscribing, you waive your right to file chargebacks
    for services already delivered.
  </p>
  <p className="text-white/80 mt-2">
    For corporate or enterprise contracts, cancellations and refunds are subject
    to the terms of the signed agreement. Unless otherwise specified in the
    contract, all payments for enterprise plans are non-refundable, and early
    termination will not relieve the client of their payment obligations for the
    agreed term.
  </p>
</section>


      {/* Acceptable Use */}
      <section>
        <h2 className="text-xl font-semibold mb-2">5. Acceptable Use</h2>
        <p className="text-white/80">
          You agree not to misuse VintariAI. Prohibited activities include (but are
          not limited to):  
        </p>
        <ul className="list-disc list-inside text-white/80 space-y-1 mt-2">
          <li>Using the Service for illegal, fraudulent, or harmful purposes.</li>
          <li>Attempting to gain unauthorized access, reverse-engineer, or
              interfere with the Service or its infrastructure.</li>
          <li>Uploading malicious code, automated scraping, or exploiting bugs.</li>
          <li>Harassment, hate speech, or generating discriminatory content.</li>
          <li>Training competing AI systems on VintariAI outputs.</li>
          <li>Misrepresenting VintariAI’s outputs as financial, legal, or medical advice.</li>
          <li>Reselling or redistributing access without written permission.</li>
        </ul>
        <p className="text-white/80 mt-2">
          Violation of this policy may result in suspension or termination of your
          account without refund.
        </p>
      </section>

      {/* Intellectual Property */}
      <section>
        <h2 className="text-xl font-semibold mb-2">6. Intellectual Property</h2>
        <p className="text-white/80">
          All content, features, branding, frameworks, and intellectual property
          associated with VintariAI are owned by us and protected by law. You are
          granted a limited, non-exclusive, non-transferable license to use the
          Service for personal or professional purposes. You may not copy, modify,
          distribute, or create derivative works without prior written consent.
        </p>
        <p className="text-white/80 mt-2">
          You retain ownership of any content you input. By using the Service, you
          grant us a limited license to process and store your content solely for
          the purpose of providing the Service.
        </p>
      </section>

      {/* AI Output Disclaimer */}
      <section>
        <h2 className="text-xl font-semibold mb-2">7. Disclaimer of AI Outputs</h2>
        <p className="text-white/80">
          VintariAI provides strategic insights generated by AI models. These
          outputs are for informational purposes only and should not be relied upon
          as professional advice. Outputs may be factually incorrect, outdated, or
          biased. The Service is experimental and provided “as is.” We expressly
          disclaim liability for reliance on outputs in regulated domains such as
          healthcare, legal, or financial advice.
        </p>
      </section>

      {/* Limitation of Liability */}
      <section>
        <h2 className="text-xl font-semibold mb-2">8. Limitation of Liability</h2>
        <p className="text-white/80">
          To the fullest extent permitted by law, VintariAI and its owners,
          employees, or affiliates shall not be liable for any indirect,
          incidental, consequential, or punitive damages, including lost profits,
          data, goodwill, or business opportunities. Our total liability shall not
          exceed the fees paid by you in the 12 months preceding the claim.
        </p>
      </section>

      {/* Termination */}
      <section>
        <h2 className="text-xl font-semibold mb-2">9. Termination</h2>
        <p className="text-white/80">
          We reserve the right to suspend or terminate your access to the Service
          at any time for conduct that violates these Terms, creates risk or legal
          exposure for us, or is otherwise harmful to other users or the Service.
          Terminated accounts may have their data deleted immediately, and refunds
          will not be issued if termination results from your violation.
        </p>
      </section>

      {/* Governing Law & Dispute Resolution */}
      <section>
        <h2 className="text-xl font-semibold mb-2">10. Governing Law & Dispute Resolution</h2>
        <p className="text-white/80">
          These Terms are governed by the laws of the State of California,
          without regard to conflict of law principles. Any disputes arising under
          these Terms will be resolved through binding arbitration in Los Angeles
          County, California under AAA rules. You waive your right to a jury trial
          and agree to resolve disputes only on an individual basis, not as a
          plaintiff or class member in any class, consolidated, or representative
          action.
        </p>
      </section>

      {/* Changes */}
      <section>
        <h2 className="text-xl font-semibold mb-2">11. Changes to Terms</h2>
        <p className="text-white/80">
          We may update these Terms from time to time. When we make material
          changes, we will notify users via email or an in-app notice. Continued
          use of the Service after changes take effect constitutes acceptance of
          the revised Terms.
        </p>
      </section>

      {/* Privacy */}
      <section>
        <h2 className="text-xl font-semibold mb-2">12. Privacy & Data Use</h2>
        <p className="text-white/80">
          Use of the Service is also governed by our Privacy Policy. By using
          VintariAI, you consent to the collection and processing of your data as
          described therein.
        </p>
      </section>

      {/* Indemnification */}
      <section>
        <h2 className="text-xl font-semibold mb-2">13. Indemnification</h2>
        <p className="text-white/80">
          You agree to indemnify and hold harmless VintariAI, its affiliates, and
          employees from any claims, damages, liabilities, or expenses arising
          from your use of the Service or violation of these Terms.
        </p>
      </section>

      {/* Force Majeure */}
      <section>
        <h2 className="text-xl font-semibold mb-2">14. Force Majeure</h2>
        <p className="text-white/80">
          We are not liable for delays or failures in performance caused by events
          beyond our reasonable control, including but not limited to natural
          disasters, internet outages, power failures, labor disputes, or
          government actions.
        </p>
      </section>

      {/* Contact */}
      <section>
        <h2 className="text-xl font-semibold mb-2">15. Contact Us</h2>
        <p className="text-white/80">
          For any questions, disputes, or cancellation requests, please contact us
          through the official support form linked on our website.
        </p>
      </section>
    </div>
  </div>
);

}

export default Terms;
